import { jsx as _jsx } from "react/jsx-runtime";
import ModalContent from './ModalContent';
const XStateCore = ({ headerRef, mainService }) => {
    return _jsx(ModalContent, { headerRef: headerRef, mainService: mainService });
};
export default XStateCore;
